import KeyContext from 'CMFW/context/KeyContext';
import ModuleContext from 'CMFW/context/ModuleContext';
import TextInput from 'CMFW/input/TextInput';
import { EditorRow } from 'components/common/styles';
import React, { useContext } from 'react';
import styled from 'styled-components';
import { IItemSource } from '../../../models/ItemModel';

const ItemSource: React.FC = () => {
  const parentKey = useContext(KeyContext);

  const module = useContext(ModuleContext);
  const moduleItemValue: IItemSource = module.getItemUpdatedValue(parentKey);

  return (
    <EditorRowStyled>
      <TextInput keyName="text" />
    </EditorRowStyled>
  );
};

const EditorRowStyled = styled(EditorRow)`
  height: 35px;
  flex-grow: 1;
`;

export default ItemSource;
